import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import PortTypeService from "@services/PortTypeService";

const ShowPortType = ({ portType }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [portTypeData, setPortTypeData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      PortTypeService.find(portType.id).then((response) => {
        setPortTypeData(response.data.data);
      });
  }, [portType.id, showModal]);

  return (
    <PermissionHandler permission={"view_port_types"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={portTypeData.name} />
          <RowDetails label={t("nameEng")} value={portTypeData.name_eng} />
          <RowDetails
            label={t("description")}
            value={portTypeData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowPortType;
